import React, { Component } from "react";
import { connect } from "react-redux";
import { getUserCourseQuizDetails } from "../../Graphs/User/UserCourseQuizDetails";
import { Table, Tooltip, Spin } from "antd";

class QuizPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { courseId, authToken } = this.props;
    let userId = this.props.adminSelectedData._id
    try {
      const response = await getUserCourseQuizDetails(authToken, {
        userId,
        courseId,
      });

      const rawQuizzes = response.data || [];

      const flattenedData = rawQuizzes.flatMap((quiz) =>
        quiz.questionData.map((question) => {
          const userAns = quiz.userAnswer.find(
            (ans) => ans.question_id === question._id
          );
          const correctOption = question.options.find((opt) => opt.is_correct);
          return {
            questionTitle: question && question.title ? question.title : "-",
            userAnswer:
              userAns && Array.isArray(userAns.answers)
                ? userAns.answers.join(", ")
                : "-",
            correctAnswer:
              correctOption && correctOption.title ? correctOption.title : "-",
            isCorrect:
              userAns && typeof userAns.is_correct === "boolean"
                ? userAns.is_correct
                : false,
          };
        })
      );

      this.setState({ data: flattenedData });
    } catch (error) {
      console.error("Error fetching quiz data:", error);
    }
  };

  counter = 0;
  tempCounter = 0;
  columns = [
    {
      title: "Question No.",
      key: "index",
      render: (text, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "Question",
      key: "questionTitle",
      dataIndex: "questionTitle",
    },
    {
      title: "Your Answer",
      key: "userAnswer",
      dataIndex: "userAnswer",
    },
    {
      title: "Correct Answer",
      key: "correctAnswer",
      dataIndex: "correctAnswer",
    },
    {
      title: "Result",
      key: "isCorrect",
      render: (text, record) => (
        <span style={{ color: record.isCorrect ? "green" : "red" }}>
          {record.isCorrect ? "Correct" : "Incorrect"}
        </span>
      ),
    },
  ];

  render() {
    const { isLoading } = this.state;

    return isLoading ? (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: 130 }}
      >
        <Spin size="large" />
      </div>
    ) : (
      <div style={{ overflowX: "auto" }}>
        <Table
          loading={isLoading}
          rowKey={(record, index) => index}
          columns={this.columns}
          size="small"
          dataSource={this.state.data}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
});

export default connect(mapStateToProps)(QuizPreview);
